import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppState } from 'src/store'
import * as routes from '../routes'
import Admin from './pages/Admin'
import Public from './pages/Public'
import Login from './security/Login'
import Signup from './security/Signup'
import ChangePassword from './security/ChangePassword'
import ResetPassword from './security/ResetPassword'
import RequestResetPassword from './security/RequestResetPassword'
import NotFound from './pages/NotFound'
import Landing from './pages/Landing';
// import About from 'src/domains/global/views/pages/About';
import About from 'src/domains/system/components/About';
import About2 from 'src/domains/system/ResumeV2/Main';


const Content: React.FC = () => {
    const loginState = useSelector((state: AppState) => state.global.login)

    return (
        <Routes>
            <Route path={routes.ROUTELOGIN} element={<Login />} />
            <Route path={routes.ROUTESIGNUP} element={<Signup />} />
            <Route path={routes.ROUTECHANGEPASSWORD} element={<ChangePassword />} />
            <Route path={routes.ROUTEREQUESTRESETPASSWORD} element={<RequestResetPassword />} />
            <Route path={routes.ROUTERESETPASSWORD} element={<ResetPassword />} />
            <Route path={routes.ROUTEADMIN + '/*'} element={loginState.token == null ? <Navigate to='/login' replace /> : <Admin />}/>            
            <Route path={routes.ROUTEHOME} element={<Landing />} />
            <Route path={routes.ROUTEUI + '/*'} element={<Public />} />
            <Route path={routes.ROUTEABOUT} element={<About />} />
            <Route path={routes.ROUTEABOUT2} element={<About2 />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

export default Content
